import { render } from "./MemoryPart.vue?vue&type=template&id=45a0597c&scoped=true"
import script from "./MemoryPart.vue?vue&type=script&lang=js"
export * from "./MemoryPart.vue?vue&type=script&lang=js"

import "./MemoryPart.vue?vue&type=style&index=0&id=45a0597c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\aarhondakis\\Desktop\\lernapp_quellcode\\lernapp-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45a0597c"]])

export default __exports__